/**
 * 跳转app私信南方号
 */

import { env } from "../config"

let openAppEnv = env === "pro" || !env ? "" : env

const openApp = ({ address, activityId, title = document.title || "南方报业小记者" }) => {
  const options = {
    id: 12,
    shareType: "share",
    title,
    isActivity: true,
    activityInfo: {
      activityId: activityId
    },
    address,
    needClipboard: true,
    openAppBigDataInfo: {
      url: address, // 当前页面URL
      origin: 3, // 引流业务场景
      sourceTag: 13, // 来源标记
      clickPosition: 30, // 引流按钮入口
      optionName: title,
      activityId: activityId,
      itemId: activityId
    }
  }
  window.console.log("options", options)
  window.OpenApp(options, openAppEnv)
}

export default openApp
